import { Button, Drawer, Form, Input, Space } from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import TextArea from "antd/es/input/TextArea";

const MerchantSaveReturnUnsave = ({
  originalTab,
  open,
  close,
  setLoading,
  rerun,
  rerunList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);

  const handleSaveToReturn = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/merchant/save-return-unsave", formdata)
      //   merchant/save-return-unsave
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Saved to return successfully.");
          setTimeout(() => {
            originalTab();
            close();
            setLoadings(false);
            setLoading(false);
            rerun();
            rerunList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Save Prepared Product for Return"
      // width={500}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="save-return"
        initialValues={{ remember: true }}
        onFinish={handleSaveToReturn}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="reason"
            label="Reason"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            {/* <Input placeholder="Set PO" size="large" /> */}

            <TextArea
              // placeholder="Set street/house/bldg./apt"

              autoSize={{
                minRows: 3,
              }}
              size="large"
              //   style={{ textTransform: "uppercase" }}
              //   disabled={allowEdit}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Save"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default MerchantSaveReturnUnsave;
